import React from "react";
import { debug } from "../utils";
import { connect } from "react-redux";
import AdditionalRecipientTableRow from "./AdditionalRecipientTableRow";
import AdditionalRecipientTableRowSkeleton from "./AdditionalRecipientTableRowSkeleton";
import { CheckboxTable } from "../view/CheckboxTable";
import { TableContext } from "../index";

function AdditionalRecipientTable({ recipients }) {
    const { config } = React.useContext(TableContext);

    const headers = [
        { name: 'FIRST NAME', onClick: () => { } },
        { name: 'LAST NAME', onClick: () => { } },
        { name: 'EMAIL', onClick: () => { } },
        { name: 'ENABLE ALERTING', onClick: () => { } }
    ]

    return (
        <>
            <CheckboxTable headers={headers} elements={recipients} containsEditButton={false} className="mt-4">
                {config.isLoading ? (
                    Array.from(new Array(10)).map((_, index) => (
                        <AdditionalRecipientTableRowSkeleton key={index} index={index} />
                    ))
                ) : (
                    recipients.map((recipient, index) => <AdditionalRecipientTableRow key={index} data={recipient} index={index} />)
                )}
            </CheckboxTable>
            {!config.isLoading && recipients.length === 0 && (
                <div className="oct_empty-state-v2">
                    <div className="oct_empty-state-title">No records found</div>
                    <div>Try adjusting your search or filters to find what you're looking for.</div>
                </div>
            )}
        </>
    )

}

function mapStateToProps(state) {
    debug("RecipientTable mapStateToProps", state);
    const page = state.alertPage;
    return {
        recipients: page.recipients || []
    };
}


export default connect(mapStateToProps)(AdditionalRecipientTable);